import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

import type { OutlineButtonVariant } from '.'

const VARIANT_COLORS: Record<OutlineButtonVariant, { border: string; fg: string }> = {
  default: { border: COLORS.strokeInput, fg: COLORS.textPrimary },
  danger: { border: COLORS.strokeInput, fg: COLORS.fgNegative },
}

export const OutlineButtonElement = styled('button', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: OutlineButtonVariant }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  padding: 12px;
  border: 1px solid ${({ variant }) => VARIANT_COLORS[variant].border};
  border-radius: 12px;
  background: transparent;
  color: ${({ variant }) => VARIANT_COLORS[variant].fg};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.08px;
  cursor: pointer;

  &[aria-busy='true'] {
    cursor: default;
  }

  &:disabled {
    color: ${COLORS.textDisabled};
    cursor: not-allowed;
  }
`
